<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-quotations_too_long_status-description') }}
        </p>

        <template v-show="!loading">
            <template v-if="external_status.length > 0">
                <div class="field">
                    <label
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('filterStatus'),
                        }"
                        >{{ t('automations-form-triggers_config-quotations_too_long_status-status_label') }}
                    </label>
                    <select v-model="filterStatus" class="form-control">
                        <option
                            v-for="status in external_status"
                            :value="status.id"
                            :key="status.id"
                        >
                            {{ status.external_label }}
                        </option>
                    </select>
                </div>

                <div class="field" v-show="!!filterStatus">
                    <label
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('filterDays'),
                        }"
                        >{{ t('automations-form-triggers_config-quotations_too_long_status-days_label') }}</label
                    >
                    <input
                        type="number"
                        v-model="filterDays"
                        class="form-control"
                    />
                </div>
            </template>
            <template v-else>
                {{ t('automations-form-triggers_config-quotations_too_long_status-no_status_help') }}
            </template>
        </template>
    </div>
</template>
<style lang="less">
.filter-value {
    .row.inputs {
        margin-top: 10px;
    }
    input {
        margin-top: 4px;
    }
}
</style>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let filterDays =
            this.value.length > 0 && this.value[0].filterDays
                ? this.value[0].filterDays
                : "";
        let filterStatus =
            this.value.length > 0 && this.value[0].filterStatus
                ? this.value[0].filterStatus
                : false;
        return {
            filterDays: filterDays,
            filterStatus: filterStatus,
            loading: false,
            external_status: [],
        };
    },
    computed: {
        errors() {
            let errors = {};

            if (!this.filterDays) {
                errors["filterDays"] = "empty";
            }

            if (!this.filterStatus) {
                errors["filterStatus"] = "empty";
            }
            return errors;
        },
    },
    mounted: function () {
        window.setTimeout(() => {
            this.changed();
        }, 100);
        this.loadData();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        loadData() {
            this.loading = true;
            let options = keviApi.getOptions(
                "settings/external-quotations-status",
                "GET",
            );
            this.$http(options).then((response) => {
                this.loading = false;
                if (response.status === 200) {
                    this.external_status = response.body.status || [];
                }
            });
        },
        isFieldValid(field) {
            return !Object.keys(this.errors).includes(field);
        },
        isValid: function () {
            return Object.keys(this.errors).length === 0;
        },
        changed: function () {
            this.$emit("input", [
                {
                    filterDays: this.filterDays,
                    filterStatus: this.filterStatus,
                },
            ]);
        },
    },
    watch: {
        filterDays: function () {
            this.changed();
        },
        filterStatus: function () {
            this.changed();
        },
        value: function () {
            let filterDays =
                this.value.length > 0 && this.value[0].filterDays
                    ? this.value[0].filterDays
                    : "";
            let filterStatus =
                this.value.length > 0 && this.value[0].filterStatus
                    ? this.value[0].filterStatus
                    : false;

            if (filterDays !== this.filterDays) {
                this.filterDays = filterDays;
            }

            if (filterStatus !== this.filterStatus) {
                this.filterStatus = filterStatus;
            }
        },
    },
};
</script>
